import { SaEntityVwcMeasurement } from './sa-entity-vwc-measurement.model';

export class SaEntityVwcHistory {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            if (json.measurements) { this.measurements = json.measurements.map(m => new SaEntityVwcHistory(m)); }
        }
    }

    entityId: string;
    entityName: string;
    measurements: SaEntityVwcMeasurement[] = [];
}

